module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgPHBhdGggZD0iTTEuNDEgNy40MUw2IDIuODNMMTAuNTkgNy40MUwxMiA2TDYgMEwwIDZMMS40MSA3LjQxWiIgZmlsbD0iIzAwMCI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/collapse_up_black.svg
// module id = XXI2
// module chunks = 6